import * as pbi from '../../public/index.component'
import { AdminService } from '../admin.service';
import { AuthorizePPService } from '../../authorizePP/authorizePP.service';
import { AppInjector } from '../../authorizePP/app-injector';

@pbi.Component({
    selector: 'header',
    templateUrl: './header.component.html'
})
export class HeaderComponent {
    pb_func: pbi.PublicComponent = new pbi.PublicComponent();
    Avatar: string = this.pb_func.NotImage;
    private authorize = AppInjector.get(AuthorizePPService);
    Unthorized: boolean = false;
    constructor(private adminService: AdminService, private router: pbi.Router) {

    }
    
    ngOnInit() {
        var this_sav = this;
        this_sav.authorize.change.subscribe(result =>{
            this_sav.Unthorized = result.status;
        });

        this_sav.pb_func.callAPI('api/User/Info', 'POST', {get:null}, null, function (status, mess) {
            if (status == 1) {
                var json_mes = JSON.parse(mess);
                
                this_sav.adminService.changeUser.subscribe(result => {
                    this_sav.Avatar = result.Avatar;
                });

                this_sav.adminService.setUserInfo(
                    json_mes.FullName, json_mes.eMail, json_mes.Phone, json_mes.More, json_mes.Avatar
                );
            }
        });
    }ng;
    
    logOut(){
        var this_sav = this;
        var data = { token: this_sav.pb_func.getToken() };
        this_sav.adminService.openLoading1();
        localStorage.removeItem(this_sav.pb_func.token);
        this_sav.pb_func.callAPI('api/User/Logout', 'POST', data, null, function(){
            this_sav.adminService.closeLoading(function(){
                setTimeout(() => { this_sav.router.navigate(['/login']); }, 400);
            });
        });
    };
}


// WEBPACK FOOTER //
// ./src/app/admin/header/header.component.ts